// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2qynB","header":"MergedInvoice_header__29VXV"};